import { watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useGtfsStore } from '@/stores/gtfs';

/**
 * A shared link may still point at a platform now merged into another stop:
 * its page would only show that platform's departures. Only a page the app was
 * opened on is redirected — within the app, the map deliberately opens one
 * platform at the "stops" zoom level. Replaced rather than pushed, so going
 * back does not land on it again; watched, since the GTFS may land after the
 * page opened.
 */
export function useCanonicalStopRedirect(stopId: () => string) {
  const route = useRoute();
  const router = useRouter();
  const gtfsStore = useGtfsStore();
  const isLandingPage = () => router.options.history.state.back == null;

  watch(
    () => gtfsStore.getCanonicalStopId(stopId()),
    canonicalId => {
      if (!isLandingPage() || canonicalId === stopId() || !gtfsStore.gtfsData.stops[canonicalId]) return;
      router.replace({
        name: route.name!,
        params: { ...route.params, stopId: canonicalId },
        query: route.query,
        hash: route.hash,
      });
    },
    { immediate: true },
  );
}
